import type { Outcome } from '@svenskaspelab/poolbetting/schema/coupon';
import type { EventNumber } from '@svenskaspelab/poolbetting/schema/sport';
import { CouponOutcomePrediction } from '@svenskaspelab/poolbetting/ui/Coupon';
import type { ReactNode } from 'react';
type GameAnalysisOutcomeProps = {
  eventAnalyses: {
    eventOutcome: (Outcome | undefined)[];
    authorName: string;
  }[];
  outcomeLabels: {
    ariaLabel: string;
    outcome: string;
  }[];
  eventNumber: EventNumber;
};

/**
 * Game analysis outcome component.
 *
 * @param root0 props
 * @param root0.eventAnalyses event analyses outcomes and author names
 * @param root0.outcomeLabels outcome labels to display
 * @param root0.eventNumber event number for bet prediction
 * @returns game analysis outcome component
 */
export function GameAnalysisOutcome({
  eventAnalyses,
  outcomeLabels,
  eventNumber
}: GameAnalysisOutcomeProps): ReactNode {
  return eventAnalyses.map((eventAnalysis, index) => <tr
  // eslint-disable-next-line react/no-array-index-key
  key={`${eventAnalysis.authorName}_${index}`} className="flex w-full justify-between gap-x-1.5 text-center">
      <th className="sr-only" scope="row">
        {eventAnalysis.authorName}s speltips
      </th>
      {outcomeLabels.map((outcomeLabel, outcomeLabelIndex) => {
      const isSelected = outcomeLabelIndex === eventAnalysis.eventOutcome[0];
      return <td className="w-full" key={outcomeLabel.outcome}>
            <CouponOutcomePrediction index={outcomeLabelIndex} eventNumber={eventNumber} outcome={outcomeLabel.outcome} isSelected={isSelected} />
          </td>;
    })}
    </tr>);
}